import { MailIcon } from "lucide-react";
import { Button, type ButtonProps } from "@/components/ui/button";

export const SUPPORT_EMAIL = "support@stryker.xyz";

type ContactSupportButtonProps = ButtonProps & {
  subject?: string;
};

export default function ContactSupportButton({
  subject,
  className,
  onClick,
  ...buttonProps
}: ContactSupportButtonProps) {
  const handleClick: ButtonProps["onClick"] = (event) => {
    const query = subject ? `?Subject=${subject}` : "";
    window.open(`mailto:${SUPPORT_EMAIL}${query}`, "_blank");
    onClick?.(event);
  };

  return (
    <Button onClick={handleClick} className={className ?? "flex items-center gap-2"} {...buttonProps}>
      <MailIcon />
      Contact us
    </Button>
  );
}
